import { useAppSelector } from "@/config/store";
import { IEdoVideostorePost } from "@/shared/model/edo-videostore-post.model";
import { EntityState } from "@/shared/reducers/reducer.utils";
import { Dialog, DialogContent, IconButton } from "@/components/ui";
import { X } from "lucide-react";
import "moment/locale/it";
import ReactPlayer from "react-player";

type IViewVideoDialogProps = {
  videostorePost: IEdoVideostorePost | null;
  open: boolean;
  onClose: () => void;
};

const ViewVideoDialog = (props: IViewVideoDialogProps) => {
  const { loading } = useAppSelector<EntityState<IEdoVideostorePost>>((state) => state.edoVideostorePost);
  const { videostorePost, open, onClose: handleClose } = props;

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent showClose={false} className="flex h-[90vh] max-h-[90vh] w-full max-w-4xl flex-col gap-0 overflow-hidden p-0">
        <div className="flex flex-shrink-0 items-center gap-3 border-b border-white/10 bg-zinc-900 px-5 py-3">
          <IconButton onClick={handleClose} aria-label="Chiudi" className="text-white hover:bg-white/10">
            <X className="h-4 w-4" />
          </IconButton>
          <h2 className="flex-1 truncate text-heading font-semibold text-white">
            {videostorePost?.title}
          </h2>
        </div>
        <div className="min-h-0 flex-1 overflow-hidden bg-black">
          {loading || !videostorePost?.video ? (
            <div className="flex h-full items-center justify-center">
              <span className="h-8 w-8 animate-spin rounded-full border-2 border-white border-t-transparent" />
            </div>
          ) : (
            <ReactPlayer
              playing
              url={`${document.location.origin}/api/videostore-posts/files/${videostorePost.video.hash}/master.m3u8`}
              controls
              width="100%"
              height="100%"
              config={{
                file: {
                  attributes: {
                    controlsList: "nodownload",
                  },
                },
              }}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ViewVideoDialog;
